import React, { memo } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';

import TableEmpty from '../../../components/TableEmpty';

const TableRows = ({ data }) => {
  if (!data.length) {
    return (
      <tr style={{ background: 'none' }}>
        <td colSpan={5}>
          <TableEmpty />
        </td>
      </tr>
    )
  }

  return data.map((report, index) => (
    <tr
      key={`table-user-${index}`}
      className={classNames({
        grey: report.suspended,
      })}
    >
      <td>
        {report.username}
      </td>
      <td>{report.orders}</td>
      <td>{report.spent}</td>
      <td>{report.profit}</td>
      <td>{report.last_order_date}</td>
    </tr>
  ));
};

TableRows.propTypes = {
  data: PropTypes.array,
};

const areEqual = (prevProps, nextProps) => {
  if (nextProps.isLoading) {
    return true;
  }
  return false;
};

export default memo(TableRows, areEqual);
